import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-button-renderer',
    templateUrl: './button-renderer.component.html',
    styleUrls: ['./button-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class ButtonRendererComponent implements OnInit {
  params: any;

  constructor() { }

  agInit(params: any): void {
    this.params = params;
    
  }

  ngOnInit(): void {
    console.info('something')
  }

  onUpdateClick(){
    console.info(this.params.data);
  }

}
